import { initialize, format } from "./Slot";

export default
  {
    // 名称
    name: "data-table-column",
    // 属性
    props:
    {
      // 原有属性
      prop:   // 数据字段名
      {
        type: String
      },
      label:  // 标题
      {
        type: String
      },
      width:  // 宽度
      {
        type: String
      },
      minWidth:  // 最小宽度
      {
        type: String
      },
      align:     // 对齐方式
      {
        type: String
      },
      headerAlign:  // 表头对齐方式
      {
        type: String
      },
      // 扩展属性
      visible:  // 是否显示
      {
        type: Boolean,
        default: true
      },
      dataType:    // 类型
      {
        type: String,
        validator: value => [undefined, "time", "dict", "number"].includes(value)
      },
      // ---------- 公共参数 ----------
      prefix:     // 前缀
      {
        type: String
      },
      suffix:     // 后缀
      {
        type: String
      },
      nullValue:  // Null值
      {
        type: String,
        default: "/"
      },
      // ---------- 类型参数 ----------
      // 时间
      timeInputFormat:  // 输入格式
      {
        type: String
      },
      timeOutputFormat: // 输出格式
      {
        type: String
      },
      // 字典
      dictClass:     // 字典分类
      {
        type: String
      },
      dictItem:     // 字典子项
      {
        type: String
      },
      // 数值
      numberRadio:    // 比率（倍数、系数）
      {
        type: Number,
        default: 1
      },
      numberPrecision:    // 精度（小数位数）
      {
        type: Number
      },
      numberThousandSign:    // 千分位
      {
        type: Boolean,
        default: false
      },
      numberMinValue:    // 最小值（小于最小值显示最小值）
      {
        type: Number
      },
      numberMaxValue:    // 最大值（大于最大值显示最大值）
      {
        type: Number
      },
      // -----------------------------
    },
    // 数据
    data()
    {
      return {
        key: 0    // 用于强制渲染数据
      }
    },
    // 创建后
    created: function ()
    {
      initialize(this);
    },
    // 方法
    methods:
    {
      // 格式化
      handleFormat(value)
      {
        return format(this, value);
      }
    }
  };



// WEBPACK FOOTER //
// ./src/components/DataTable/DataTableColumn/index.js